export default __webpack_public_path__ + "static/fk-bbf6a79c8784c908ebf63794bea48e58.svg";